import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import { ChartElement } from '.';

export default class Shareholders extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }
  get tableData() {
    return JSON.parse(get(this, '_tabelka_akcjonariuszy.value', []));
  }
  get shareholderChartData() {
    return get(this, '_akcjonariat_wykres.value', new ChartElement());
  }
}



// WEBPACK FOOTER //
// ./src/models/Shareholders.model.js